import React from 'react';
import { Flex } from '@wegroup/design-system';
import { chakraCustomScrollBar } from '../../../../../../../common/src/utils/styledComponentsUtils';
import ScrollDownButtonContainer from '../scroll-button/ScrollDownButtonContainer';
import useHandleButtonScroll from '../../hooks/useHandleButtonScroll';
import { AdvisoryFlowMainContainerId } from './AdvisoryFlowMainContainer';

const AdvisoryFlowMainContainerHomeContent: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children, ...otherProps }) => {
  const { scrollContainer, isScrollable, setIsScrollable } =
    useHandleButtonScroll();

  return (
    <Flex
      flexGrow={1}
      pos="absolute"
      top="14"
      left="14"
      bottom="14"
      alignItems="center"
      {...otherProps}
    >
      {/* Scroll button */}
      <ScrollDownButtonContainer
        scrollContainer={scrollContainer}
        isScrollable={isScrollable}
        setIsScrollable={setIsScrollable}
        position="absolute"
      />
      <Flex
        id={AdvisoryFlowMainContainerId}
        flexDir="column"
        bg="white"
        position="relative"
        overflowY={{ base: 'unset', laptop: 'auto' }}
        sx={chakraCustomScrollBar}
        borderRadius="md"
        boxShadow="level3"
        h="100%"
        w="2xl"
        zIndex="1"
      >
        {children}
      </Flex>
    </Flex>
  );
};

export default AdvisoryFlowMainContainerHomeContent;
